/* ── Barcode generator ── */
function Barcode() {
  const bars = [2, 4, 2, 3, 5, 2, 3, 4, 2, 3];
  return (
    <div className="flex gap-0.5 items-stretch h-[clamp(46px,6vh,64px)]">
      {bars.map((w, i) => (
        <div
          key={i}
          className="bg-t-dim rounded-[1px] opacity-45"
          style={{ width: `${w}px` }}
        />
      ))}
    </div>
  );
}

/* ── Stamp ── */
function Stamp() {
  return (
    <div
      className="w-[clamp(48px,6.5vw,58px)] h-[clamp(48px,6.5vw,58px)] rounded-full border-2 border-mint flex flex-col items-center justify-center text-center opacity-70 transition-opacity duration-300 group-hover:opacity-100"
      style={{ transform: "rotate(-18deg)" }}
    >
      <span className="text-[.85rem] text-mint leading-none">✓</span>
      <span className="font-mono text-[.38rem] tracking-[.1em] text-mint uppercase leading-[1.25]">
        LANDED
        <br />
        SAFELY
      </span>
    </div>
  );
}

/* ── Boarding Pass ── */
function BoardingPass({
  variant,
  fromCode,
  fromName,
  toCode,
  toName,
  track,
  gate,
  project,
  projectEn,
  desc,
  delay,
}) {
  const stripe =
    variant === "ai"
      ? "bg-gradient-to-l from-[#E8733A] to-[#D85A30]"
      : "bg-gradient-to-l from-[#22B58A] to-[#1A9070]";

  return (
    <div
      className={`group relative bg-[#091A2B] rounded-[14px] overflow-hidden flex flex-col border border-[rgba(109,211,167,0.1)] transition-all duration-300 hover:-translate-y-1 hover:rotate-[.25deg] hover:shadow-[0_20px_48px_rgba(8,24,40,.65)] hover:border-[rgba(109,211,167,.22)] anim-up`}
      style={{ animationDelay: `${delay}s` }}
    >
      {/* stripe */}
      <div className={`h-1 flex-shrink-0 ${stripe}`} />

      <div className="flex flex-1">
        {/* main */}
        <div className="flex-1 p-[clamp(12px,1.6vw,18px)] border-l border-dashed border-[rgba(109,211,167,0.09)] flex flex-col">
          {/* route */}
          <div className="flex items-center gap-2 mb-[clamp(10px,1.4vh,16px)]">
            <div className="text-center">
              <span
                className="font-mono text-t-primary leading-none block tracking-[.04em]"
                style={{
                  fontSize: "clamp(1.3rem,2vw,1.8rem)",
                  fontWeight: 700,
                }}
              >
                {fromCode}
              </span>
              <span className="font-mono text-[.52rem] text-t-dim block mt-0.5">
                {fromName}
              </span>
            </div>
            <div className="flex-1 flex items-center gap-1">
              <span
                className="flex-1 h-px"
                style={{
                  background:
                    "repeating-linear-gradient(90deg,#3D6278 0,#3D6278 3px,transparent 3px,transparent 7px)",
                }}
              />
              <span
                className="text-[.9rem] text-mint"
                style={{ transform: "rotate(180deg)", display: "inline-block" }}
              >
                ✈
              </span>
              <span
                className="flex-1 h-px"
                style={{
                  background:
                    "repeating-linear-gradient(90deg,#3D6278 0,#3D6278 3px,transparent 3px,transparent 7px)",
                }}
              />
            </div>
            <div className="text-center">
              <span
                className="font-mono text-t-primary leading-none block tracking-[.04em]"
                style={{
                  fontSize: "clamp(1.3rem,2vw,1.8rem)",
                  fontWeight: 700,
                }}
              >
                {toCode}
              </span>
              <span className="font-mono text-[.52rem] text-t-dim block mt-0.5">
                {toName}
              </span>
            </div>
          </div>

          {/* details row */}
          <div className="grid grid-cols-3 gap-1.5 mb-[clamp(8px,1.2vh,14px)]">
            <div>
              <span className="font-mono text-[.48rem] tracking-[.1em] uppercase text-t-dim block mb-0.5">
                المسار
              </span>
              <span className="text-[.74rem] font-semibold text-t-primary font-cairo">
                {track}
              </span>
            </div>
            <div>
              <span className="font-mono text-[.48rem] tracking-[.1em] uppercase text-t-dim block mb-0.5">
                المدة
              </span>
              <span className="font-mono text-[.68rem] font-semibold text-t-primary">
                10 WKS
              </span>
            </div>
            <div>
              <span className="font-mono text-[.48rem] tracking-[.1em] uppercase text-t-dim block mb-0.5">
                الصيف
              </span>
              <span className="font-mono text-[.68rem] font-semibold text-t-primary">
                2025
              </span>
            </div>
          </div>

          {/* project */}
          <h4
            className="font-cairo font-black text-t-primary tracking-tight mb-[.2rem]"
            style={{
              fontSize: "clamp(.95rem,1.3vw,1.15rem)",
              letterSpacing: "-.02em",
            }}
          >
            {project}
          </h4>
          {projectEn && (
            <span className="font-mono text-[.56rem] text-t-dim tracking-[.05em] block mb-[.6rem]">
              {projectEn}
            </span>
          )}
          <p className="text-[.74rem] text-t-sec leading-[1.7] flex-1">
            {desc}
          </p>
        </div>

        {/* stub */}
        <div className="w-[clamp(76px,11%,100px)] flex-shrink-0 p-[clamp(10px,1.4vw,14px)_8px] flex flex-col items-center gap-2 bg-[rgba(8,24,40,.45)]">
          <Barcode />
          <Stamp />
          <div className="text-center">
            <span className="font-mono text-[.42rem] text-t-dim tracking-[.1em] uppercase block mb-0.5">
              Gate
            </span>
            <span className="font-mono text-[.72rem] font-bold text-t-primary">
              {gate}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ── Gauge ── */
function Gauge({ n, unit, label, sub, isFirst }) {
  return (
    <div className="relative bg-ink-deep text-center transition-colors duration-200 hover:bg-[#0A1F35] p-[clamp(16px,2.2vh,26px)_14px]">
      <div className="relative w-[clamp(48px,5vw,66px)] h-[clamp(48px,5vw,66px)] rounded-full border-[1.5px] border-[rgba(109,211,167,0.2)] flex items-center justify-center mx-auto mb-2.5">
        {/* inner ring */}
        <span className="absolute inset-1 rounded-full border border-[rgba(109,211,167,0.08)]" />
        {/* live dot on first gauge */}
        {isFirst && (
          <span className="absolute top-1 right-1 w-1.5 h-1.5 rounded-full bg-mint blink-dot" />
        )}
        <span>
          <span
            className="font-cairo font-black text-mint leading-none block"
            style={{ fontSize: "clamp(1rem,1.5vw,1.4rem)" }}
          >
            {n}
          </span>
          <span className="font-mono text-[.44rem] text-t-dim block mt-px tracking-[.06em] uppercase">
            {unit}
          </span>
        </span>
      </div>
      <span className="text-[.63rem] text-t-sec leading-[1.35] block">
        {label}
      </span>
      <span className="font-mono text-[.52rem] text-t-dim block mt-[3px]">
        {sub}
      </span>
    </div>
  );
}

const PASSES = [
  {
    variant: "cy",
    toCode: "WTQ",
    toName: "وثيق",
    track: "Cybersecurity",
    gate: "CY-1",
    project: "وثيق",
    projectEn: "WATHIQ · Digital Trust System",
    desc: "نظام توثيق رقمي يعزز الثقة والشفافية في التعاملات الإلكترونية بأدوات أمنية متقدمة.",
    delay: 0.38,
  },
  {
    variant: "ai",
    toCode: "GFI",
    toName: "GreenFi",
    track: "AI in Business",
    gate: "AI-1",
    project: "قرينفاي",
    projectEn: null,
    desc: "منصة تمويل خضراء تستخدم الذكاء الاصطناعي لتقييم المشاريع المستدامة وتوجيه المستثمرين.",
    delay: 0.44,
  },
  {
    variant: "ai",
    toCode: "RFQ",
    toName: "رفيق",
    track: "AI in Business",
    gate: "AI-2",
    project: "رفيق",
    projectEn: null,
    desc: "مساعد ذكي يرافق الخريجين في مسيرتهم المهنية بتوصيات مخصصة للفرص والمقابلات.",
    delay: 0.5,
  },
  {
    variant: "ai",
    toCode: "MDD",
    toName: "مداد",
    track: "AI in Business",
    gate: "AI-3",
    project: "مداد",
    projectEn: null,
    desc: "أداة ذكاء اصطناعي لتوليد المحتوى العربي وتحليله للمؤسسات والأفراد بكفاءة عالية.",
    delay: 0.55,
  },
  {
    variant: "ai",
    toCode: "REC",
    toName: "مدقق",
    track: "AI in Business",
    gate: "AI-4",
    project: "مدقق العقارات",
    projectEn: null,
    desc: "نظام AI يحلل التقارير العقارية السعودية ويكشف التناقضات والأخطاء التسعيرية تلقائياً.",
    delay: 0.6,
  },
  {
    variant: "ai",
    toCode: "AIM",
    toName: "AIM",
    track: "AI in Business",
    gate: "AI-5",
    project: "AIM",
    projectEn: null,
    desc: "منصة لدمج حلول الذكاء الاصطناعي في العمليات التجارية وتحليل سير العمل لتحسين الكفاءة.",
    delay: 0.65,
  },
  {
    variant: "cy",
    toCode: "CHK",
    toName: "CyberHook",
    track: "Cybersecurity",
    gate: "CY-2",
    project: "CyberHook",
    projectEn: null,
    desc: "أداة اختبار اختراق تكشف ثغرات تطبيقات الويب وفق OWASP وتولّد تقارير أمنية احترافية.",
    delay: 0.69,
  },
  {
    variant: "cy",
    toCode: "NWS",
    toName: "NWSA",
    track: "Cybersecurity",
    gate: "CY-3",
    project: "NWSA",
    projectEn: null,
    desc: "نظام متكامل لرصد أمن الشبكات وتطبيقات الويب في الوقت الفعلي مع تنبيهات ذكية.",
    delay: 0.73,
  },
];

export default function Proof() {
  return (
    <section
      className="relative overflow-hidden px-[clamp(16px,5vw,80px)] py-[clamp(64px,9vh,110px)]"
      id="proof"
    >
      {/* top divider */}
      <div
        className="absolute top-0 left-[clamp(16px,5vw,80px)] right-[clamp(16px,5vw,80px)] h-px"
        style={{
          background:
            "linear-gradient(90deg,transparent,rgba(109,211,167,0.11) 30%,rgba(109,211,167,0.11) 70%,transparent)",
        }}
      />
      {/* bg glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 50% 100%,rgba(109,211,167,0.04) 0%,transparent 70%),radial-gradient(ellipse 40% 30% at 10% 30%,rgba(242,185,73,0.03) 0%,transparent 60%)",
        }}
      />

      {/* ── Header ── */}
      <div
        className="text-center mb-[clamp(48px,6vh,72px)] relative z-[2] anim-up"
        style={{ animationDelay: ".05s" }}
      >
        <span className="inline-flex items-center gap-2 font-mono text-[.68rem] tracking-[.2em] uppercase text-mint font-semibold mb-[1.2rem] before:content-['◆'] before:text-[.4rem] before:opacity-40 after:content-['◆'] after:text-[.4rem] after:opacity-40">
          AFQ · سجل الرحلات المكتملة
        </span>
        <h2
          className="font-cairo font-black leading-[1.1] tracking-tight text-t-primary mb-[.7rem]"
          style={{ fontSize: "clamp(1.9rem,3.5vw,3.1rem)" }}
        >
          مشاريع <em className="not-italic text-mint">حطّت بأمان</em>
        </h2>
        <p className="text-[.95rem] text-t-sec leading-[1.85] max-w-[500px] mx-auto">
          كل بطاقة هنا تمثّل رحلة حقيقية. متدرب أقلع من الصفر وهبط بمشروع يُضيفه
          لملفه المهني.
        </p>
      </div>

      {/* ── Section label + legend ── */}
      <div
        className="flex items-center justify-between mb-[clamp(16px,2.5vh,24px)] relative z-[2] flex-wrap gap-2.5 anim-up"
        style={{ animationDelay: ".35s" }}
      >
        <h3
          className="font-cairo font-extrabold text-t-primary tracking-tight"
          style={{
            fontSize: "clamp(1.1rem,1.8vw,1.5rem)",
            letterSpacing: "-.02em",
          }}
        >
          بطاقات الصعود —{" "}
          <em className="not-italic text-gold">رحلات نفخر بها</em>
        </h3>
        <div className="flex items-center gap-3.5">
          <span className="flex items-center gap-1.5 font-mono text-[.66rem] text-t-dim">
            <span className="w-5 h-[3px] rounded-[2px] bg-[#D85A30]" />
            AI Track
          </span>
          <span className="flex items-center gap-1.5 font-mono text-[.66rem] text-t-dim">
            <span className="w-5 h-[3px] rounded-[2px] bg-[#1A9070]" />
            Cyber Track
          </span>
        </div>
      </div>

      {/* ── Boarding passes grid ── */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-[clamp(10px,1.5vw,18px)] relative z-[2]">
        {PASSES.map((p) => (
          <BoardingPass key={p.gate} {...p} fromCode="AFQ" fromName="آفاق" />
        ))}
      </div>

      {/* ── Quote bar ── */}
      <div
        className="mt-[clamp(40px,5vh,60px)] relative z-[2] border border-[rgba(109,211,167,0.1)] rounded-[14px] p-[clamp(24px,3vh,36px)_clamp(24px,4vw,48px)] bg-[#081828] flex items-center gap-[clamp(24px,4vw,56px)] flex-wrap anim-up"
        style={{ animationDelay: ".76s" }}
      >
        {/* rating */}
        <div className="flex-shrink-0 text-center">
          <span
            className="font-cairo font-black text-mint leading-none block tracking-tight"
            style={{
              fontSize: "clamp(3.5rem,6vw,6rem)",
              letterSpacing: "-.04em",
            }}
          >
            9.25
          </span>
          {/* stars */}
          <div className="flex gap-[3px] justify-center my-[.4rem]">
            {[...Array(5)].map((_, i) => (
              <svg
                key={i}
                className="w-[13px] h-[13px] text-gold"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
            ))}
          </div>
          <span className="font-mono text-[.6rem] text-t-dim tracking-[.1em]">
            TRAINEE RATING / 10
          </span>
        </div>

        {/* divider */}
        <div className="w-px h-[clamp(60px,8vh,90px)] bg-[rgba(109,211,167,.1)] flex-shrink-0 hidden sm:block" />

        {/* quote */}
        <div className="flex-1 min-w-[200px]">
          <p
            className="text-t-sec leading-[1.9] mb-[.8rem]"
            style={{ fontSize: "clamp(.88rem,.95rem,1.05rem)" }}
          >
            هذا التدريب ما كان مجرد ساعات عمل — بل كان{" "}
            <strong className="text-t-primary">
              محطة لاستكشاف كيف التقنيات الحديثة تغيّر عالمنا
            </strong>
            ، وكيف ممكن نكون جزء من صناعتها وحمايتها.
          </p>
          <span className="font-mono text-[.56rem] text-t-dim tracking-[.06em] flex items-center gap-1.5">
            <span className="text-[.42rem] text-mint">◆</span>
            من تقييمات خريجي رحلة آفاق ٢٠٢٥ — +٢٠ متدرب أتمّوا الرحلة
          </span>
        </div>
      </div>
    </section>
  );
}
